import React from 'react'

import { ReactComponent as CheckFilledCircleIcon } from '@app/assets/Small/Filled/CheckCircle.svg'
import { ReactComponent as CheckCircleIcon } from '@app/assets/Small/Outline/CheckCircle.svg'
import { ReactComponent as PencilIcon } from '@app/assets/Small/Outline/Pencil.svg'
import { ReactComponent as TrashIcon } from '@app/assets/Small/Outline/Trash.svg'
import { bemJoin } from '@app/lib/bem'

import { useDocumentCardHandlers } from '../hooks/useDocumentCardHandlers'

import { ActionButton } from './ActionButton'

import './DocumentActions.scss'

type DocumentActionsProps = {
  onCheckmarkClick?: (checked: boolean) => void
  onRenameClick?: () => void
  onRemove?: () => void
  isChecked: boolean
  handlers: ReturnType<typeof useDocumentCardHandlers>
}

export const DocumentActions: React.FC<DocumentActionsProps> = ({
  onCheckmarkClick,
  onRenameClick,
  onRemove,
  isChecked,
  handlers
}) => {
  if (!onCheckmarkClick && !onRenameClick && !onRemove) return null

  const b = bemJoin('document-actions')

  return (
    <>
      {onCheckmarkClick && (
        <ActionButton
          onClick={handlers.handleCheckmarkClick}
          className={b('checkmark', { checked: isChecked })}
          icon={isChecked ? <CheckFilledCircleIcon /> : <CheckCircleIcon />}
          ariaLabel={isChecked ? 'Uncheck document' : 'Check document'}
        />
      )}
      {onRenameClick && (
        <ActionButton
          onClick={handlers.handleEditClick}
          className={b('edit')}
          icon={<PencilIcon />}
          ariaLabel='Edit document'
        />
      )}
      {onRemove && (
        <ActionButton
          onClick={handlers.handleRemoveClick}
          className={b('delete')}
          icon={<TrashIcon />}
          ariaLabel='Delete document'
        />
      )}
    </>
  )
}
